<template lang="html">
  <div class="contact-path">
    <ContactPathSetting></ContactPathSetting>
  </div>
</template>

<script>
import ContactPathSetting from './contact-path-setting.vue';

export default {
  components: {
    ContactPathSetting
  }
};
</script>

<style lang="scss" scoped>

</style>
